export const specials = [
  {
    id: 's-3001',
    title: '暑期档观影指南',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20summer%20movie%20season%20banner%20with%20warm%20orange%20and%20deep%20red%20gradients%2C%20glowing%20spotlights%20and%20film%20elements%2C%20vibrant%20entertainment%20atmosphere%2C%20clean%20dark%20composition%20with%20negative%20space&width=1200&height=675&seq=special-summer-01&orientation=landscape',
    intro: '一年一度的暑期档再度开启，科幻、悬疑、现实题材轮番登场。本专题为你梳理最值得关注的影片与看点，帮你在众多选择中快速找到属于自己的那一部。',
    editorNote: '暑期档一直是全年最具活力的一段时间，类型丰富、话题密集。我们更希望你带着轻松的心态走进影院，在光影里找到属于自己的那份感动。',
    newsIds: ['n-1001', 'n-1006', 'n-1010', 'n-1014'],
    videoIds: ['v-2001', 'v-2004', 'v-2006'],
    tags: ['暑期档', '电影', '观影'],
    updateDate: '2026-10-14',
  },
  {
    id: 's-3002',
    title: '综艺新势力观察',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20variety%20show%20banner%20with%20geometric%20LED%20panels%2C%20warm%20orange%20stage%20lighting%2C%20modern%20entertainment%20atmosphere%2C%20red%20accents%2C%20clean%20composition%20with%20negative%20space&width=1200&height=675&seq=special-variety-02&orientation=landscape',
    intro: '当综艺不再只追求流量，内容本身开始重新成为主角。本专题聚焦近期的综艺新趋势，从赛制创新到幕后制作，带你重新认识这个热闹的领域。',
    editorNote: '真正让一档节目留下来的，从来不是一时的热度，而是它能否与观众建立真实的连接。',
    newsIds: ['n-1002', 'n-1005', 'n-1013'],
    videoIds: ['v-2002', 'v-2005', 'v-2007', 'v-2011'],
    tags: ['综艺', '趋势', '舞台'],
    updateDate: '2026-10-13',
  },
  {
    id: 's-3003',
    title: '音乐现场全记录',
    cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20abstract%20music%20festival%20banner%20with%20warm%20orange%20and%20red%20stage%20lights%2C%20crowd%20silhouettes%2C%20glowing%20sound%20wave%20patterns%2C%20energetic%20cinematic%20atmosphere%2C%20clean%20dark%20backdrop&width=1200&height=675&seq=special-music-03&orientation=landscape',
    intro: '从新歌发布到音乐节现场，从盛典舞台到巡演日记，本专题带你走进声音的世界，感受现场演出独有的温度与力量。',
    editorNote: '现场的意义，在于所有人都身处同一段旋律之中，那种共同的呼吸感，是屏幕无法完全替代的。',
    newsIds: ['n-1003', 'n-1007', 'n-1013'],
    videoIds: ['v-2003', 'v-2005', 'v-2008'],
    tags: ['音乐', '现场', '演出'],
    updateDate: '2026-10-12',
  },
  {
    id: 's-3004',
    title: '明星面对面',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20celebrity%20interview%20banner%20with%20soft%20warm%20studio%20lighting%2C%20blurred%20amber%20and%20red%20tones%2C%20refined%20editorial%20atmosphere%2C%20clean%20dark%20composition%20with%20negative%20space&width=1200&height=675&seq=special-star-04&orientation=landscape',
    intro: '聚光灯之外，他们同样是认真生活的人。本专题汇集演员、歌手与创作者的真实分享，透过镜头与文字，走近他们作品背后的故事。',
    editorNote: '去掉标签之后，每个人都在为热爱的事情投入时间，这些细节往往比舞台上的样子更打动人。',
    newsIds: ['n-1004', 'n-1011', 'n-1015'],
    videoIds: ['v-2009', 'v-2001'],
    tags: ['明星', '专访', '人物'],
    updateDate: '2026-10-11',
  },
  {
    id: 's-3005',
    title: '幕后与真实',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20behind-the-scenes%20banner%20with%20camera%20and%20clapperboard%20silhouettes%2C%20soft%20amber%20lighting%2C%20documentary%20atmosphere%2C%20cinematic%20depth%2C%20clean%20dark%20backdrop%20with%20negative%20space&width=1200&height=675&seq=special-backstage-05&orientation=landscape',
    intro: '一部作品从构想到完成，往往要走很远的路。本专题记录那些不为大众所见的幕后时刻，以及真实生活里同样动人的平凡故事。',
    editorNote: '很多珍贵的瞬间并不在聚光灯下，而恰恰藏在反复打磨与认真生活的过程当中。',
    newsIds: ['n-1008', 'n-1012', 'n-1009'],
    videoIds: ['v-2001', 'v-2007', 'v-2010', 'v-2012'],
    tags: ['幕后', '纪录片', '真实'],
    updateDate: '2026-10-10',
  },
];